var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.aslInterface),expression:"aslInterface"}],staticClass:"btn num-btn",on:{"click":_vm.handleASLButtonClick}},[_c('img',{staticClass:"soft-img icon",attrs:{"src":"/images/icn-asl-hand.svg","alt":""}}),_c('div',{staticClass:"letters"},[_vm._v("ASL remote")])])
}
var staticRenderFns = []

export { render, staticRenderFns }